import { render, staticRenderFns } from "./SortingIndex.vue?vue&type=template&id=4cef7244&"
import script from "./SortingIndex.vue?vue&type=script&lang=js&"
export * from "./SortingIndex.vue?vue&type=script&lang=js&"
import style0 from "./SortingIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports